import { ComponentProps, useEffect } from 'react';

import { CarouselSection } from 'src/general/components/Carousel/CarouselSection';
import { IntersectionObserverHandler } from 'src/general/components/IntersectionObserverHandler/IntersectionObserverHandler';
import { pushToDataLayerFeatureEngagement } from 'src/utils/pushToDataLayerFeatureEngagement';

type Props = {
  tiles: ComponentProps<typeof CarouselSection>['tiles'];
  carouselName?: string;
};

export const RecentlyViewedCarouselSection = ({ tiles, carouselName }: Props) => {
  useEffect(() => {
    pushToDataLayerFeatureEngagement({
      event: 'feature_engagement',
      payload: {
        type: 'load',
        feature: 'recentlyViewed',
        component: 'carousel',
      },
    });
  }, []);
  return (
    <IntersectionObserverHandler
      margins="-50%"
      onIntersecting={() => {
        pushToDataLayerFeatureEngagement({
          event: 'feature_engagement',
          payload: {
            type: 'view',
            feature: 'recentlyViewed',
            component: 'carousel',
          },
        });
      }}
    >
      <CarouselSection tiles={tiles} carouselName={carouselName} variant="recently-viewed" />
    </IntersectionObserverHandler>
  );
};
